import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetCheckout } from "./checkoutSlice";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import orderService from "services/orderService";
import { fetchOrders, setOrderCancelling } from "./ordersSlice";

export const clearOrderState = () => (dispatch) => {
	dispatch(resetOrderState());
	dispatch(resetCheckout());
};

export const cancelOrder = createAsyncThunk(
	"vino/order/cancel",
	async (order, { dispatch }) => {
		try {
			dispatch(setOrderCancelling(order.id, true));
			dispatch(showLoader());
			await orderService.cancel(order);
			dispatch(fetchOrders());
		} catch (e) {
			console.error(e);
			dispatch(
				showMessage({
					message: "Error occurred while cancelling order",
					variant: "error",
				})
			);
		} finally {
			dispatch(hideLoader());
			dispatch(setOrderCancelling(order.id, false));
		}
	}
);

const orderSlice = createSlice({
	name: "vino/order",
	initialState: {},
	reducers: {
		setInvoice: (state, action) => {
			state.invoice = action.payload;
		},
		resetOrderState: (state) => {
			state.invoice = null;
		},
	},
	extraReducers: {},
});

export const { setInvoice, resetOrderState } = orderSlice.actions;

export default orderSlice.reducer;
